import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import {
  IStripePriceOptionsResponse,
  StripePriceProduct,
} from '@sleipai/sleip-models';
import { from, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StripePriceProductService {
  private functions = inject(Functions);
  private http = inject(HttpClient);

  constructor() {}

  loadActiveStripePriceProductsList() {
    const priceProductsCallable = httpsCallable(
      this.functions,
      'stripeApi-getStripeProducts'
    );
    return from(priceProductsCallable()).pipe(
      map((priceProductsResponse) => priceProductsResponse.data as []),
      map((priceProducts) =>
        priceProducts.map(
          (priceProduct) => new StripePriceProduct(priceProduct)
        )
      )
    );
  }

  getStripePriceOptionsForProduct(
    currency: string,
    interval: string,
    userType: string
  ): Observable<IStripePriceOptionsResponse> {
    const projectId = 'sleip-dev';
    const region = 'europe-west1';

    const functionsBaseUrl = `https://${region}-${projectId}.cloudfunctions.net`;

    return this.http.get<IStripePriceOptionsResponse>(
      `${functionsBaseUrl}/stripeApi-getPriceOptions`,
      {
        params: { currency, interval, userType },
      }
    );
  }
}
